import { Mandate } from '../../domain/Authorization/entities';
import { MandatePayroll } from '../../domain/Authorization/entities';
import { TransactionWithDealerRate } from '../../../../transaction/src/domain/Transaction/entities/TransactionWithDealerRate';
import { NotificationsProviderState } from './types';

const defaultNotificationsProviderState: NotificationsProviderState = {
  authorizationsList: [] as Mandate[],
  transactionsList: [] as TransactionWithDealerRate[],
  payrollList: [] as MandatePayroll[],
  onToggleNotificationsSnackbar: () => {},
  isNotificationsSnackbarOpen: true,
  loadingState: {
    isLoadingPendingAuthorizations: false,
  },
  errorState: {
    pendingAuthorizationsListError: undefined,
  },
  onRefetchPendingAuthizationsListMutation: () => {},
};

export { defaultNotificationsProviderState };
